import React from 'react';
import _orderBy from 'lodash-es/orderBy';
import useSchoolyears from '@teetsh/app/src/queries/schoolyears/useSchoolyears';
import { MenuItemsLoader } from '@teetsh/app/src/containers/App/Breadcrumb/MenuItemsLoader';
import {
  Menu,
  SECTION_TITLE_STYLE,
  SELECTED_ITEM_STYLE,
} from '@teetsh/app/src/components/Menu';
import { CheckIcon as Check } from '@heroicons/react/20/solid';
import { Schoolyear } from '@teetsh/app/src/types/schoolyear';
import 'twin.macro';

interface Props {
  schoolyear: Schoolyear;
  onClick: (v: Schoolyear) => void;
  label?: string;
  children?: React.ReactNode;
}

export function SchoolyearsMenuItems(props: Props) {
  const { schoolyear, onClick, label, children } = props;
  const { data, isLoading } = useSchoolyears();

  if (isLoading) {
    return <MenuItemsLoader />;
  }
  const schoolyears = data || [];
  return (
    <>
      <div>
        {label && <p css={SECTION_TITLE_STYLE}>{label}</p>}
        {_orderBy(schoolyears, 'year', ['desc']).map(scy => (
          <Menu.Item
            key={scy.id}
            icon={scy.id === schoolyear.id ? Check : 'div'}
            css={scy.id === schoolyear.id && SELECTED_ITEM_STYLE}
            onClick={() => onClick(scy)}
            text={scy.label}
          />
        ))}
      </div>
      {children}
    </>
  );
}
